<template>
  <div class="public-service-links-grid">
    <component v-if="title" :is="titleTag" class="mb-30 flex flex-align-items-center">
      <vz-icon
        v-if="titleIconUrl"
        :url="titleIconUrl"
        variant="primary"
        no-masked-icon
        class="mr-15"
        size=36
      />
      {{ title }}
    </component>
    <slot name="prepend" />
    <div class="public-service-links-grid-items" :class="{compact: compact || textOnly, 'text-only': textOnly}">
      <div
        v-for="(item, index) of items"
        :key="index"
        class="public-service-links-grid-item"
        :class="{ 'vz-cursor-pointer': !!item.link?.to }"
        @click="onClick(item.link?.to)"
      >
        <vz-icon
          v-if="textOnly"
          name="arrow-top-right-thick"
          variant="primary"
          size="24"
        />
        <vz-icon
          v-else
          :name="item.icon.name"
          :url="item.icon.url"
          :no-masked-icon="!!item.icon.url"
          variant="primary"
          size="36"
          class="mb-30"
        />
        <nuxt-link 
          :to="item.link?.to"
          @click.stop
          class="public-service-links-grid-item-title"
        >
          <span v-html="item.title" />
        </nuxt-link>
        <div v-if="item.text" class="public-service-links-grid-item-text mt-20">
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { PublicInfoGridItem } from '~~/types/public'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  titleIconUrl: {
    type: String,
    default: ''
  },
  titleH3 : {
    type: Boolean,
    default: false
  },
  items: {
    type: Array as PropType<PublicInfoGridItem[]>, 
    default: () => []
  },
  textOnly: {
    type: Boolean,
    default: false
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const titleTag = computed(() => {
  return props.titleH3 ? 'h3' : 'h2'
})

function onClick(path: any) {
  if (path) {
    useRouter().push(path)
  }
}
</script>
